const DEFAULT = "default";
const ACTIVE = "active";
const INACTIVE = "inactive";
const COMPLETED = "completed";
const ERROR = "error";
const CONDITION = "condition";
const HIDE = "hide";

export const stepStatusMap = {
  DEFAULT,
  COMPLETED,
  ERROR
};

export const cardStatusMap = {
  DEFAULT,
  COMPLETED,
  ERROR
};

export const groupStatusMap = {
  ACTIVE,
  INACTIVE,
  CONDITION,
  HIDE
};

export default {
  stepStatusMap,
  cardStatusMap,
  groupStatusMap
};
